module.exports = __webpack_public_path__ + "img/6_79.657a8f57.png";